<template>
  <div class="restaurant-modifiers-option">
    <div class="row my-3">
      <h2 class="">{{ $t('modifiersOption.title') }}</h2>
    </div>
    <div class="row">
      <div class="col-12 mb-4">
        <button @click="returnBack" class="btn btn-sm btn-outline-success me-2">{{ $t('modifiersOption.goBack') }}</button>
        <a @click="openModalForAdd" class="btn btn-sm btn-warning px-3 me-2">{{ $t('modifiersOption.createOption') }}</a>
      </div>
      <div v-for="(option, index) in this.OPTIONS"
           @click="openModalForChange(option)"
           :key="index"
           class="col-4 col-md-3 col-lg-2">
        <div class="card position-relative mb-4">
          <div class="card-remove position-absolute top-0 end-0 pt-2 pe-2">
            <button
                @click.stop
                @click="openModalRemoveOption(option)"
                class="btn btn-outline-danger pt-0 p-1">
              <svg width="1rem" height="1rem" fill="currentColor">
                <use xlink:href="../../assets/ico/bootstrap-icons.svg#trash3-fill"/>
              </svg>
            </button>
          </div>
          <div style="height: 100px;" class="card-img text-center mt-2">
            <img v-if="option.src" :src="option.src" class="img-fluid h-100" :alt="option.title">
            <img v-else src="../../assets/img/placeholder-option.png" class="img-fluid h-100" :alt="option.title">
          </div>
          <div class="card-body p-2">
            <p class="mb-1 fw-bold">{{ option.administrative_name }}
              <svg v-show="option.description" width="1rem" height="1rem" fill="gray" data-bs-toggle="tooltip" data-bs-placement="top" :title="option.description">
                <use xlink:href="../../assets/ico/bootstrap-icons.svg#info-circle"/>
              </svg>
            </p>
            <div class="mb-2">
              <svg width="1rem" height="1rem" fill="gray" class="mb-1">
                <use xlink:href="../../assets/ico/bootstrap-icons.svg#archive"/>
              </svg> {{ option.category }}
            </div>
            <div class="border-1 border-top d-flex justify-content-between">
              <span>{{ option.price }} {{ $t('modifiersOption.currency') }}</span>
              <span>{{option.weight}} {{ $t('modifiersOption.weightUnit') }}</span>
            </div>

          </div>
        </div>
      </div>
    </div>
<!--    modal option-->
    <div class="modal fade" id="modalOption" tabindex="-1" aria-labelledby="modalOptionLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalOptionLabel">{{this.modalTitle}}
              <span v-show="this.MODIFIERS_LOADING.add" class="spinner-border spinner-border-sm text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
            </h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body row">
            <div class="col-12 col-md-6 mb-3">
              <label for="optionTitleAdmin" class="form-label">{{ $t('modifiersOption.newOption.adminPanelTitle') }}</label>
              <input v-model.trim="newOption.administrative_name" type="text" class="form-control" id="optionTitleAdmin">
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="optionTitle" class="form-label">{{ $t('modifiersOption.newOption.websiteTitle') }}</label>
              <input v-model.trim="newOption.title" type="text" class="form-control" id="optionTitle">
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="optionCategory" class="form-label">{{ $t('modifiersOption.newOption.category') }}</label>
              <input v-model.trim="newOption.category" type="form-control" class="form-control" id="optionCategory" list="optionCategoryList">
              <datalist id="optionCategoryList">
                <option v-for="cat in this.OPTIONS_CAT" :value="cat">{{ cat }}</option>
              </datalist>
            </div>
            <div class="col-6 col-lg-3 mb-3">
              <label for="optionWeight" class="form-label">{{ $t('modifiersOption.newOption.weight') }}</label>
              <input v-model.number.trim="newOption.weight"
                     type="number" class="form-control" id="optionWeight">
            </div>
            <div class="col-6 col-lg-3 mb-3">
              <label for="optionPrice" class="form-label">{{ $t('modifiersOption.newOption.price') }}</label>
              <input v-model.number.trim="newOption.price"
                     type="number" class="form-control" id="optionPrice">
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="optionDescription" class="form-label">{{ $t('modifiersOption.newOption.description') }}</label>
              <input v-model.trim="newOption.description" type="text" class="form-control" id="optionDescription">
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="optionImageFile" class="form-label">{{ $t('modifiersOption.newOption.image') }}</label>
              <input class="form-control" type="file" id="optionImageFile" aria-describedby="optionImageHelp">
              <div id="optionImageHelp" class="form-text">{{ $t('modifiersOption.newOption.imageRequirements') }}<br>{{ $t('modifiersOption.newOption.imageRequirementsResolution') }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('modifiersOption.newOption.close') }}</button>
            <button v-if="this.MODIFIERS_LOADING.add" class="btn btn-btn-success" type="button" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ $t('modifiersOption.newOption.loading') }}
            </button>
            <button
                v-show="this.modalType === 'add' && !this.MODIFIERS_LOADING.add"
                @click="addOption"
                :disabled="this.disableSendBtn"
                type="button" class="btn btn-success">{{ $t('modifiersOption.newOption.save') }}
            </button>
            <button
                v-show="this.modalType === 'change' && !this.MODIFIERS_LOADING.add"
                @click="changeOption"
                type="button" class="btn btn-success">{{ $t('modifiersOption.newOption.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
<!--    modal remove option-->
    <div class="modal fade" id="modalRemoveOption" tabindex="-1" aria-labelledby="modalRemoveOptionLabel" aria-hidden="true">
      <div class="modal-dialog modal-sm modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalRemoveOptionLabel">{{ $t('modifiersOption.deleteOption') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <img :src="removeOption.src" class="img-fluid h-100 mb-3" :alt="removeOption.title">
              <p>{{ $t('modifiersOption.delete') }} <b>{{removeOption.title}}</b> ?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('modifiersOption.no') }}</button>
            <button
                @click="deleteOption"
                data-bs-dismiss="modal"
                type="button" class="btn btn-danger">{{ $t('modifiersOption.yes') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import i18n from "@/i18n";
import {mapGetters} from 'vuex';
import {Tooltip, Modal} from "bootstrap";

export default {
  name: "ModifiersOption",
  data() {
    return {
      modalType: 'add', //modal window for add option or change
      newOption: {
        administrative_name: '',
        title: '',
        category: '',
        description: '',
        price: 0,
        weight: 0
      },
      removeOption: {

      }
    }
  },
  computed: {
    ...mapGetters([
      'OPTIONS',
      'OPTIONS_CAT',
      'MODIFIERS_LOADING',
    ]),
    modalTitle() {
      if (this.modalType === 'add') {return i18n.global.t('modifiersOption.addOption')}
      if (this.modalType === 'change') {return i18n.global.t('modifiersOption.updateOption')}
    },
    disableSendBtn() {
      if (
          this.newOption.administrative_name &&
          this.newOption.title &&
          this.newOption.category
      ) {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    returnBack() {
      router.go(-1)
    },
    clearInputs() {
      this.newOption = {
        administrative_name: '',
        title: '',
        category: '',
        description: '',
        price: 0,
        weight: 0,
      }
      document.querySelector('#optionImageFile').value = ''
    },
    async addOption() {
      let restId = this.$route.params.id
      let newOption = this.newOption
      let img = document.querySelector('#optionImageFile').files[0]
      let optionIsAdding = await this.$store.dispatch('addOption', {restId, newOption, img})
      if (optionIsAdding) {
        this.closeModal()
      }
    },
    async changeOption() {
      let restId = this.$route.params.id
      let newOption = this.newOption
      let img = document.querySelector('#optionImageFile').files[0]
      let optionIsChanging = await this.$store.dispatch('changeOption', {restId, newOption, img})
      if (optionIsChanging) {
        this.closeModal()
      }
    },
    openModalForAdd() {
      this.clearInputs();
      this.modalType = 'add';
      const optionModal = new Modal(document.querySelector('#modalOption'));
      optionModal.show();
    },
    openModalForChange(option) {
      this.newOption.administrative_name = option.administrative_name
      this.newOption.title = option.title
      this.newOption.category = option.category
      this.newOption.description = option.description
      this.newOption.price = option.price
      this.newOption.weight = option.weight
      this.newOption.id = option.id
      document.querySelector('#optionImageFile').value = '';
      this.modalType = 'change';
      const optionModal = new Modal(document.querySelector('#modalOption'));
      optionModal.show();
    },
    openModalRemoveOption(option) {
      this.removeOption = option
      let optionRemoveModal = new Modal(document.querySelector('#modalRemoveOption'));
      optionRemoveModal.show();
    },
    deleteOption() {
      this.$store.dispatch('deleteOption', this.removeOption)
    },
    closeModal() {
      const openModal = document.getElementById('modalOption')
      let modal = Modal.getOrCreateInstance(openModal);
      modal.hide();
    },
  },
  mounted() {
    let restId = this.$route.params.id
    if(!Object.values(this.OPTIONS).length) {
      this.$store.dispatch('getOptions', restId)
    }
    // initialization bootstrap tooltips
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  }
}
</script>

<style scoped>

</style>
